












































import Vue from 'vue'
import AmataModal from '@/components/AmataModal/AmataModal.vue'
import PaymentList from '@/components/PaymentList.vue'
import PaymentListItem from '@/components/PaymentListItem.vue'
import HavePoint from '@/components/HavePoint.vue'
import * as qs from 'qs'
import { mapGetters, mapMutations } from 'vuex'
import { sleep } from '@/utils/helpers'
import InAppPurchase from '@/inapp-purchase'

export default Vue.extend({
  name: 'StorePayment',
  components: {
    'amata-modal': AmataModal,
    HavePoint,
    PaymentList,
    PaymentListItem
  },
  data() {
    return {
      iap: null,
      isActiveModal: false,
      menus: {},
      ids: [],
      productList: {},
      isLoading: false,
      disabledButtons: {},
      orderId: ''
    }
  },
  computed: {
    ...mapGetters('MyData', ['myPoint'])
  },
  async created() {
    if (this.$_hasCordova) {
      this.isLoading = true

      this.iap = new InAppPurchase()
      const data = await this.iap.fetchAppPayment().catch(async err => {
        console.error(err)
        await this.$_alert(err)
        this.$router.back()
      })
      this.menus = data.menus
      this.ids = Object.keys(this.menus)

      // 無効ボタンのプロパティを初期化
      for (let i = 0; i < this.ids.length; i++) {
        this.$set(this.disabledButtons, this.ids[i], false)
      }

      this.iap.init(this.menus)
      this.iap.on('ready', this.handleReady.bind(this))
      this.iap.on('updated', this.handleUpdated.bind(this))
      this.iap.on('error', this.handleError.bind(this))
      this.iap.on('validator', this.handleValidator.bind(this))
    }

    if (this.$_platformIsAndroid) {
      document.addEventListener('backbutton', this.handleBackbutton, false)
    }

    // TODO: 無課金判定、初回購入バナーダイアログ表示
    // TODO: 課金済み判定、多くのポイント購入を促すバナーダイアログ表示
  },
  destroyed() {
    if (!this.$_hasCordova) {
      return
    }

    if (this.$_platformIsAndroid) {
      document.removeEventListener('backbutton', this.handleBackbutton, false)
    }

    if (this.iap) {
      this.iap.off('ready', this.handleReady.bind(this))
      this.iap.off('updated', this.handleUpdated.bind(this))
      this.iap.off('error', this.handleError.bind(this))
      this.iap.off('validator', this.handleValidator.bind(this))
    }
  },
  methods: {
    ...mapMutations('MyData', ['setMyPoint']),

    /**
     * アプリ課金の準備が完了
     */
    handleReady() {
      console.log('[handleReady]')
      for (let i = 0; i < this.ids.length; i++) {
        const params = this.getPuchaseParams(this.ids[i])
        this.$set(this.productList, this.ids[i], params)
      }
      this.isLoading = false
    },

    /**
     * 決済が完了したらボタンの無効化を解除する
     */
    handleUpdated(product) {
      console.log('[handleUpdated]', product)
      if (product.id === this.orderId && product.state === store.VALID) {
        this.$set(this.disabledButtons, product.id, false)
        this.isLoading = false
      }
    },

    /**
     * エラー
     */
    handleError(err: Error) {
      console.error('[handleError]', err)
      this.$set(this.disabledButtons, this.orderId, false)
    },

    /**
     * 決済の成否判定
     */
    async handleValidator({ product, data, error }) {
      this.$set(this.disabledButtons, this.orderId, false)

      if (error) {
        console.error('[handleValidator]', error)
      } else if (data.result === 'OK') {
        this.setMyPoint(data.point)
        await this.$_alert(data.body, data.title)
        this.$router.replace('/mypage')
      }
    },

    /**
     * 商品一覧用の product paramter を返す
     */
    getPuchaseParams(id: string): any {
      const params = { id: id }
      for (const key of Object.keys(this.menus[id])) {
        params[key] = this.menus[id][key]
      }
      return params
    },

    /**
     * 商品一覧を返す
     */
    getProducts(): any {
      return this.productList
    },

    /**
     * アイテムの注文
     */
    async order(id: string) {
      // どれか一つでも決済ボタンを押したならオーダー中として他のオーダーを無視する
      const isOrdering = Object.values(this.disabledButtons).some(value => {
        return value === true
      })
      if (this.isLoading || isOrdering) {
        return
      }
      this.isLoading = true
      console.log('[order]')

      this.$set(this.disabledButtons, id, true)
      this.$forceUpdate()
      this.orderId = id
      await sleep(300)

      // 万が一決済途中でアク禁になることを防ぐ
      const data = await this.iap.fetchAppPayment().catch(err => {
        console.error(err)
        this.$set(this.disabledButtons, id, false)
      })
      if (data.error && data.error === 'Access error.') {
        this.$set(this.disabledButtons, id, false)
        this.$router.back()
        return
      }

      store.order(id)
    },

    /**
     * 読み込み中=オーダー中 はバックボタン無効化
     */
    handleBackbutton(e: Event) {
      e.preventDefault()
      if (!this.isLoading) {
        this.$router.back()
      }
    }
  }
})
